import React from "react";
import { useTranslation } from "react-i18next";
import { GenericPaginatedScroll } from "./GenericPaginatedScroll";
import { IsoStartEndDatePicker } from "./IsoStartEndDatePicker";


export function GenericLogsPage({
    nextPage,
    isRequesting,
    requestingFirst,

    content,
    
    otherFilters,

    startIsoString,
    endIsoString,
    timezone,

    handleNextPage = () => {},
    handleLogsDateStartChange = (date) => {},
    handleLogsDateEndChange = (date) => {},

    isThereLogs = false,
    compactDates = false,
    hideDates = false,
} = {}) {

    //LIBRARIES
    const { t } = useTranslation();

    //VIEW
    return (
        <div
            className="
                h-100
                w-100
                mh-100

                d-flex
                no-gutters
                flex-column

                overflow-auto
            "
        >
            {!hideDates && <div className="mt-2"/>}
            {!hideDates && (
                <div className={`
                    ${compactDates ? "" : "w-100"}
                    d-flex
                    align-items-center
                    ${compactDates ? "" : "justify-content-between"}
                    flex-wrap
                    mb-3
                `}>
                    <IsoStartEndDatePicker
                        startIsoDate={startIsoString}
                        endIsoDate={endIsoString}
                        handleStartDateChange={handleLogsDateStartChange}
                        handleEndDateChange={handleLogsDateEndChange}
                        timezone={timezone}
                        compact={compactDates}
                    />
                </div>
            )}

            {otherFilters && (
                <div className="my-2">
                    {otherFiltersSection()}
                </div>
            )}
            <GenericPaginatedScroll
                content={content}
                handleNextPage={handleNextPage}
                isRequesting={isRequesting}
                isRequestingFirst={requestingFirst}
                isThereContent={isThereLogs}
                isLastPage={nextPage === -1}

                noContentMessage={t("logs.noLogsFound")}
                getNextPageString={t("logs_load_more_logs")}
                noMoreContentString={t("logs_no_more_logs")}
            />
        </div>
    );

    function otherFiltersSection() {
        if (!otherFilters)
            return;
        
        return (
            <>
                {otherFilters}
            </>
        );
    }

}